import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Group, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeResourceFromResourceGroup(
    request: Boundaries["removeResourceFromResourceGroup"]["request"],
  ): void;
}

function useRemoveResourceFromResourceGroup(
  group: Identifiable<Group>,
  resource: Identifiable<any>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveResourceFromResourceGroupRequestPending(group, resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveResourceFromResourceGroupRequestSuccess(group, resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveResourceFromResourceGroupRequestFailure(group, resource),
    ),
    removeResourceFromResourceGroup: core.removeResourceFromResourceGroup,
  };
}

export { useRemoveResourceFromResourceGroup };
